(function(){
  const stores = window.SB_STORES || [];
  const platformAssets = window.SB_PLATFORM_ASSETS || {};
  const root = document.querySelector('[data-sb-locator]');
  if(!root || !stores.length) return;
  const stateEl = root.querySelector('[data-filter-state]');
  const cityEl = root.querySelector('[data-filter-city]');
  const localityEl = root.querySelector('[data-filter-locality]');
  const searchEl = root.querySelector('[data-filter-search]');
  const countEl = root.querySelector('[data-store-count]');
  const listEl = root.querySelector('[data-store-list]');
  const nearBtn = root.querySelector('[data-use-location]');
  let currentPosition = null;

  const uniq = arr => [...new Set(arr.filter(Boolean))].sort((a,b)=>a.localeCompare(b));
  const escapeHtml = s => String(s||'').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  const optionize = (el, values, placeholder) => {
    const old = el.value;
    el.innerHTML = `<option value="">${placeholder}</option>` + values.map(v=>`<option value="${escapeHtml(v)}">${escapeHtml(v)}</option>`).join('');
    if(values.includes(old)) el.value = old;
  };
  const distanceKm = (a,b,c,d) => {
    if([a,b,c,d].some(v=>v==null || isNaN(v))) return 999999;
    const R=6371, toRad=x=>x*Math.PI/180;
    const dLat=toRad(c-a), dLon=toRad(d-b);
    const x=Math.sin(dLat/2)**2+Math.cos(toRad(a))*Math.cos(toRad(c))*Math.sin(dLon/2)**2;
    return 2*R*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
  };
  const openLabel = s => String(s.status||'Live').toLowerCase().includes('coming') ? 'COMING SOON' : 'OPEN';

  function hydrateFilters(){
    optionize(stateEl, uniq(stores.map(s=>s.state)), 'All states');
    refreshCityLocality();
  }
  function refreshCityLocality(){
    const state = stateEl.value;
    const cityScope = state ? stores.filter(s=>s.state===state) : stores;
    optionize(cityEl, uniq(cityScope.map(s=>s.city)), 'All cities');
    const city = cityEl.value;
    const localities = city ? cityScope.filter(s=>s.city===city).map(s=>s.locality) : cityScope.map(s=>s.locality);
    optionize(localityEl, uniq(localities), 'All localities');
  }

  function platformContent(key, fallbackText){
    const logoUrl = platformAssets[`${key}Logo`];
    if(logoUrl){
      return `<img src="${escapeHtml(logoUrl)}" alt="${escapeHtml(fallbackText)}" loading="lazy">`;
    }
    return `<span>${escapeHtml(fallbackText)}</span>`;
  }

  function platformLinks(s){
    const links = [];
    const ownlyUrl = s.ownly || '';
    if(ownlyUrl) links.push(`<a class="sb-platform ownly" href="${escapeHtml(ownlyUrl)}" target="_blank" rel="noopener" aria-label="Order on Ownly">${platformContent('ownly','Ownly')}</a>`);
    if(s.swiggy) links.push(`<a class="sb-platform swiggy" href="${escapeHtml(s.swiggy)}" target="_blank" rel="noopener" aria-label="Order on Swiggy">${platformContent('swiggy','Swiggy')}</a>`);
    if(s.zomato) links.push(`<a class="sb-platform zomato" href="${escapeHtml(s.zomato)}" target="_blank" rel="noopener" aria-label="Order on Zomato">${platformContent('zomato','Zomato')}</a>`);
    if(s.maps_url) links.push(`<a class="sb-platform maps" href="${escapeHtml(s.maps_url)}" target="_blank" rel="noopener" aria-label="Open Google Maps">${platformContent('maps','Google Maps')}</a>`);
    return links.join('');
  }

  function card(s){
    const dist = currentPosition && s.lat && s.lng ? `<p class="sb-meta">Approx. ${distanceKm(currentPosition.lat,currentPosition.lng,s.lat,s.lng).toFixed(1)} km away</p>` : '';
    const services = (s.services||[]).slice(0,4).map(x=>`<span class="sb-chip">${escapeHtml(x)}</span>`).join('');
    const orderTarget = s.ownly || s.swiggy || s.zomato || s.page_url || '#';
    return `<article class="sb-card">
      <div class="sb-card-top"><p class="sb-city"><span class="sb-icon">⌖</span>${escapeHtml(s.city)}</p><span class="sb-status">${openLabel(s)}</span></div>
      <h3>${escapeHtml(s.name)}</h3>
      <p class="sb-meta sb-location"><span class="sb-icon">⌾</span><span>${escapeHtml(s.locality)}, ${escapeHtml(s.city)}, ${escapeHtml(s.state)}</span></p>
      ${dist}
      <div class="sb-divider"></div>
      <p class="sb-time"><span class="sb-icon">◷</span><span>Weekdays: ${escapeHtml(s.weekday || 'Timing to be updated')}<br>Weekend: ${escapeHtml(s.weekend || 'Timing to be updated')}</span></p>
      <div class="sb-chiprow">${services}</div>
      <div class="sb-card-footer">
        <a class="sb-btn" href="${escapeHtml(s.page_url || orderTarget)}">View Store <span>›</span></a>
        <div class="sb-platforms">${platformLinks(s)}</div>
      </div>
    </article>`;
  }

  function apply(){
    const state = stateEl.value, city = cityEl.value, locality = localityEl.value, q = (searchEl.value||'').toLowerCase().trim();
    let rows = stores.filter(s=>(!state || s.state===state)&&(!city || s.city===city)&&(!locality || s.locality===locality));
    if(q) rows = rows.filter(s => [s.name,s.state,s.city,s.locality,s.store_code].join(' ').toLowerCase().includes(q));
    if(currentPosition) rows.sort((a,b)=>distanceKm(currentPosition.lat,currentPosition.lng,a.lat,a.lng)-distanceKm(currentPosition.lat,currentPosition.lng,b.lat,b.lng));
    countEl.textContent = `${rows.length} store${rows.length===1?'':'s'} found`;
    listEl.innerHTML = rows.map(card).join('') || '<div class="sb-card sb-empty"><h3>No stores found</h3><p class="sb-meta">Try another city or locality search.</p></div>';
  }

  [stateEl,cityEl,localityEl].forEach(el=>el.addEventListener('change',()=>{ if(el===stateEl) refreshCityLocality(); apply(); }));
  searchEl.addEventListener('input', apply);
  nearBtn && nearBtn.addEventListener('click',()=>{
    if(!navigator.geolocation){ alert('Location is not available on this browser.'); return; }
    navigator.geolocation.getCurrentPosition(pos=>{ currentPosition={lat:pos.coords.latitude,lng:pos.coords.longitude}; apply(); },()=>alert('Please allow location access to sort stores near you.'));
  });
  hydrateFilters(); apply();
})();
